// extracted by mini-css-extract-plugin
export var askAiIcon = "_oi-k";
export var category = "_oi-a";
export var categoryHeader = "_oi-f";
export var container = "_oi-0";
export var group = "_oi-b";
export var groupItems = "_oi-g";
export var groupSeparator = "_oi-l";
export var highlight = "_oi-8";
export var loading = "_oi-1";
export var noResults = "_oi-3";
export var placeholder = "_oi-2";
export var resultContent = "_oi-5";
export var resultIcon = "_oi-d";
export var resultItem = "_oi-h";
export var resultMeta = "_oi-9";
export var resultSubtitle = "_oi-7";
export var resultSuffix = "_oi-j";
export var resultTitle = "_oi-6";
export var resultsList = "_oi-4";
export var searchGroup = "_oi-e";
export var selected = "_oi-i";
export var subgroup = "_oi-c";